import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { stack } from '@/uiPrimitives/layout/stack';
import { textBlock, textInline } from '@/uiPrimitives/typography/text';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { H2TextBlock } from '@/uiComposites/typography/headings';
import { placement } from '@/uiPrimitives/layout/placement.css';
import { WebAPISubsidyResult } from '@/globals/webApiTypes/elements/WebAPISubsidy';
import { translateInline } from '@/globals/translate/translateInline';
import { RegionalBlock } from './RegionalBlock';
import { pluralize } from '@/globals/helpers/pluralize';
import { getStatusText } from './subsidyFilter/subsidyFilterKeys';
export const Results = t0 => {
  const $ = _c(21);
  const {
    results,
    regionalSubsidiesPage
  } = t0;
  const t1 = results?.length ?? 0;
  let t2;
  if ($[0] !== t1) {
    t2 = pluralize(t1, {
      none: translateInline({
        en: "No schemes found",
        nl: "Geen regelingen gevonden"
      }),
      single: translateInline({
        en: "scheme",
        nl: "regeling"
      }),
      plural: translateInline({
        en: "schemes",
        nl: "regelingen"
      })
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const resultCountText = t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classes(stack({
      gap: "7 | betweenH3Sections"
    }));
    t4 = addTestSelector("uiResultList");
    t5 = classes(textBlock({
      capSize: "-1 | small",
      color: "positive"
    }));
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = addTestSelector("uiFilterResultCount");
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== results?.length) {
    t7 = (results?.length ?? 0) > 0 && <><span className={classes(textInline({
        fontWeight: "bold"
      }))}>{results?.length ?? 0}</span>{" "}</>;
    $[6] = results?.length;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== resultCountText || $[9] !== t7) {
    t8 = <div className={t5} role="status" {...t6}>{t7}{resultCountText}</div>;
    $[8] = resultCountText;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== results) {
    t9 = results ?? [];
    $[11] = results;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = t9.map(_temp);
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== regionalSubsidiesPage) {
    t11 = <RegionalBlock regionalSubsidiesPage={regionalSubsidiesPage} />;
    $[15] = regionalSubsidiesPage;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t8) {
    t12 = <div className={t3} {...t4}>{t8}{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
function _temp(t0) {
  const {
    href,
    title,
    status,
    text,
    scheme
  } = t0;
  const statusText = getStatusText(status);
  const types = [...(scheme ? [scheme] : [])];
  return <div key={href} className={classes(stack({
    gap: "2 | h2"
  }))}><DOPLink data-link-type="subsidiesResult" href={href} className={classes(stack({
      gap: "2 | h2"
    }))}><H2TextBlock size="h4" textBlockProps={{
        color: "positiveBlue",
        textDecorationLine: "underline"
      }}>{title}</H2TextBlock>{status != null && <p className={classes(textBlock({
        textDecorationLine: "none",
        fontStyle: "italic",
        color: "positiveRed",
        capSize: "-2 | smaller"
      }))}>{statusText}</p>}<p className={classes(textBlock({
        textDecorationLine: "none",
        fontVariantNumeric: "oldstyle-nums"
      }))}>{text}</p></DOPLink>{types != null && types.length > 0 && <p className={classes(textBlock({
      textDecorationLine: "none",
      color: "positiveMuted",
      capSize: "-2 | smaller"
    }), placement({
      order: "-1"
    }))}>{types.join(", ")}</p>}</div>;
}